module.exports = __webpack_public_path__ + "static/media/faq-375.56c69d22.jpg";